<template>
    <div class="note-modal">
        <div class="note-modal__wrap">
            <div class="row">
                <div
                    class="col-xl-9 col-lg-9 col-md-9"
                    style="padding-right: 16px"
                >
                    <div class="form-field form-field--inline-flex">
                        <label>Subject <sub>*</sub></label>
                        <input
                            placeholder="About"
                            id="subject-input"
                            name="subject-input"
                            v-model="note.title"
                        />
                        <span class="error" v-if="errors.title">{{
                            errors.title
                        }}</span>
                    </div>
                </div>
                <div class="col-xl-2 col-lg-2 col-md-2">
                    <div
                        class="form-field checkbox-wrap"
                        style="margin-bottom: 1em; font-weight: 600"
                        v-if="isAdmin"
                    >
                        <input
                            type="checkbox"
                            id="only_for_admin"
                            name="only-for-admin"
                            v-model="note.only_for_admin"
                        />
                        Private
                        <label for="only_for_admin">
                            <i class="icon icon-checkmark"></i>
                        </label>
                    </div>
                </div>
                <div class="col-xl-1 col-lg-1 col-md-1">
                    <div
                        class="btn btn--icon-border"
                        type="button"
                        @click="onSave"
                    >
                        <i class="icon icon-checkmark"></i>
                    </div>
                </div>
            </div>
            <div class="row">
                <div
                    class="form-field form-field--textarea form-field--inline-flex"
                >
                    <textarea
                        placeholder="Detailed Note"
                        id="note-input"
                        name="note-input"
                        v-model="note.body"
                    ></textarea>
                    <span class="error" v-if="errors.body">{{
                        errors.body
                    }}</span>
                </div>
            </div>
        </div>
    </div>
    <!-- <div class="modal" id="modal-edit-note" aria-hidden="true">
        <div class="modal-overflow" tabindex="-1">
            <div class="modal-window">
                <div class="btn btn-modal-close" @click="closeModal()">
                    <i class="icon icon-cancel"></i>
                </div>
                <div class="modal-header">
                    <h2>Edit note</h2>
                </div>
                <div class="modal-body">
                    <form class="form-agency-new-note">
                        <div class="row">
                            <div class="form-field form-field--inline-flex">
                                <label>Subject <sub>*</sub></label>
                                <input
                                    placeholder="About"
                                    id="subject-input"
                                    name="subject-input"
                                    v-model="note.title"
                                />
                                <span class="error" v-if="errors.title">{{
                                    errors.title
                                }}</span>
                            </div>
                            <div
                                class="form-field form-field--textarea form-field--inline-flex"
                            >
                                <label>Note <sub>*</sub></label>
                                <textarea
                                    placeholder="Detailed Note"
                                    id="note-input"
                                    name="note-input"
                                    v-model="note.body"
                                ></textarea>
                                <span class="error" v-if="errors.body">{{
                                    errors.body
                                }}</span>
                            </div>
                            <div class="form-field--space-around w-100">
                                <div
                                    class="form-field checkbox-wrap"
                                    v-if="isAdmin"
                                >
                                    <input
                                        type="checkbox"
                                        id="only_for_admin_edit"
                                        name="only-for-admin"
                                        v-model="note.only_for_admin"
                                    />
                                    <label for="only_for_admin_edit"
                                        ><i class="icon icon-checkmark"></i>
                                        Show only for admin
                                    </label>
                                </div>
                                <div class="form-field form-field--btn">
                                    <div @click="onSave" class="btn btn--gray">
                                        Save
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div> -->
</template>

<script>
import axios from "axios";

export default {
    name: "editNote",
    props: {
        isAdmin: {
            type: Boolean,
            default: false,
        },
        editId: {
            type: String | Number | null,
            default: null,
        },
        editData: {
            type: Object | null,
            default: null,
        },
        onUpdate: {
            type: Function,
            default: () => {},
        },
        onCloseModal: {
            type: Function,
            default: () => {},
        },
    },

    watch: {
        editData: function (newVal) {
            if (newVal) {
                this.note.id = newVal.id;
                this.note.title = newVal.title;
                this.note.body = newVal.body;
                this.note.only_for_admin = Boolean(newVal.only_for_admin);
            }
        },
    },

    mounted() {
        if (this.editId) {
            this.note = this.editData;
        }
    },

    data() {
        return {
            note: {
                id: "",
                title: "",
                body: "",
                only_for_admin: false,
            },
            errors: {
                title: null,
                body: null,
            },
        };
    },

    methods: {
        closeModal() {
            this.onCloseModal();
        },

        async onSave() {
            this.validateFields();

            if (this.errors.title || this.errors.body) {
                return;
            }

            await axios
                .post(`/notes/${this.editId}/update`, {
                    title: this.note.title,
                    body: this.note.body,
                    only_for_admin: this.note.only_for_admin,
                })
                .then(() => {
                    this.onUpdate(this.editId, this.note);
                })
                .catch((err) => console.log("Update note error", err))
                .finally(() => this.closeModal());
        },
        validateFields() {
            this.errors.title = null;
            this.errors.body = null;

            if (!this.note.title) {
                this.errors.title = "Required";
            }
            if (!this.note.body) {
                this.errors.body = "Required";
            }
        },
    },
};
</script>
